import { Icon } from '@/components/ui/icon';
import { CONTROL_SIZE } from '@/components/ui/input';
import { cn } from '@/lib/cn';

export interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  'aria-label'?: string;
}

/** Search box with a leading icon and a clear button once there is a term. */
export function SearchInput({
  value,
  onChange,
  placeholder = 'Search…',
  className,
  'aria-label': ariaLabel = 'Search',
}: SearchInputProps) {
  return (
    <div className={cn('relative w-full sm:w-auto', className)}>
      <Icon
        name="search"
        size={14}
        className="pointer-events-none absolute top-1/2 left-2.5 -translate-y-1/2 text-content-subtle"
      />

      <input
        type="search"
        value={value}
        aria-label={ariaLabel}
        placeholder={placeholder}
        onChange={(event) => {
          onChange(event.target.value);
        }}
        className={cn(
          'border-border-strong bg-surface text-content placeholder:text-content-subtle',
          CONTROL_SIZE,
          'w-full rounded-sm border pr-8 pl-8 hover:border-content-subtle',
          /* Overrides CONTROL_SIZE's own padding: the icons need the room. */
          'px-8',
          'transition-colors duration-100',
          /* The browser's own clear affordance would be a default control. */
          '[&::-webkit-search-cancel-button]:appearance-none',
        )}
      />

      {value && (
        <button
          type="button"
          aria-label="Clear search"
          onClick={() => {
            onChange('');
          }}
          className="absolute top-1/2 right-2 -translate-y-1/2 rounded-sm p-0.5 text-content-subtle hover:text-content"
        >
          <Icon name="close" size={12} />
        </button>
      )}
    </div>
  );
}
